/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import React, { useEffect, useState } from 'react'
import CustomTooltip from '../CustomTooltip/CustomTooltip'
import moment from 'moment'
import type { appConfigs } from '../types/types'
import { getESPConnectionData } from 'src/services/emailAPIESPServices';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { ViewStrokeRounded,Image03Icon } from '@hugeicons-pro/core-stroke-rounded';
import TemplatePreview from '../TemplatePreview/TemplatePreview';
import {RESENDTOOPTIONS, BULK_UNSUBSCRIBE_LEVELS, PRIORITY_OPTIONS } from 'src/constants/constant';
import CustomDataTable from '../CustomDataTable/CustomDataTable';
import type { TableColumn } from 'react-data-table-component';

interface BulkEmailReviewProps {
  bulkEmailData: any;
  bulkEmailCreatedUser?: string | "";
  bulkEmailCreatedOn?: string | "";
  estimatedEndDate?: string;
  seedListName?: string;        
  suppressionListName?: string; 
  totalRecipientCount?: number;
  seedDataCount?: number;
  suppressedCount?: number;
  clientCampaignId?: string | null;
}

    // Helper function to get send order label
    const getSendOrderLabel = (index: number): string => {
      const labels = [
        'Initial', 'Resend 1', 'Resend 2', 'Resend 3', 'Resend 4',
        'Resend 5', 'Resend 6', 'Resend 7', 'Resend 8', 'Resend 9', 'Resend 10'
      ];
      return labels[index] || `Resend ${index}`;
    };

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function BulkEmailReview({ bulkEmailData, bulkEmailCreatedOn, bulkEmailCreatedUser, seedListName, suppressionListName, suppressedCount: suppressedCountProp, seedDataCount: seedDataCountProp, totalRecipientCount: totalRecipientCountProp, clientCampaignId  }: BulkEmailReviewProps): JSX.Element {
    console.log('bulkEmailData in review:', bulkEmailData);
    const campaign = bulkEmailData ?? {};
    const suppressedCount = suppressedCountProp;
    const seedCount = seedDataCountProp;
    const totalRecipientCount = totalRecipientCountProp;
    const displayClientCampaignId = (clientCampaignId ?? campaign.clientCampaignId) || 'N/A';
    // const [isLoading, setIsLoading] = useState<boolean>(false)
    const [isDataLoading, setIsDataLoading] = useState<boolean>(false)
    const [previewContent, setPreviewContent] = useState<string>("");
    const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
    const [imageError, setImageError] = useState(false);
    const [espConnectionName, setEspConnectionName] = useState<string>('');
    const storedAppConfig = localStorage.getItem("appConfigs");
    const userData = JSON.parse(localStorage.getItem("user") ?? "{}");
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-unsafe-member-access
    const fullname = `${userData.firstName ?? ""} ${userData.lastName ?? ""}`.trim();
    const parsedAppConfig = storedAppConfig
        ? (JSON.parse(storedAppConfig) as appConfigs[])
        : []; // Default to an empty array if null

    const TemplateImagePublicURL = parsedAppConfig.find(
        (item) => item.configName === "TemplateImagePublicURL"
    )?.configValue;

    useEffect(() => {
      setImageError(false);
    }, [campaign?.templateIdentifier]);

    useEffect(() => {
      if (!campaign.espConnectionId) return;
      getESPConnectionData()
        .then((res: any) => {
          if (res.status === 200) {
            const espAllData: any[] = res?.data?.data ?? [];
            const match = espAllData.find((e: any) => String(e.id) === String(campaign.espConnectionId));
            setEspConnectionName(match?.connectionName ?? '');
          }
        })
        .catch(() => { /* silent */ });
    }, [campaign.espConnectionId]);

    console.log(campaign);

    // Define columns for CustomDataTable
    const scheduleColumns: TableColumn<any>[] = [
    {
      name: 'Send',
      selector: (_row, index) => index ?? 0,
      width: '25%',
      cell: (_row, index) => (
        <span className="text-14 text-gray-800 font-medium">
          {getSendOrderLabel(index ?? 0)}
        </span>
      ),
      sortable: false,
    },
    {
      name: 'Date & Time',
      selector: (row: any) => row.dateTime,
      width: '45%',
      cell: (row: any) => (
        <span className="text-14 text-gray-700">
            {row.dateTime
                                                            ? (() => {
                                                                const [datePart, timePart] = row.dateTime.split("T");
                                                                const [year, month, day] = datePart.split("-");
                                                                const [hour, minute] = timePart.substring(0,5).split(":");

                                                                let h = parseInt(hour, 10);
                                                                const ampm = h >= 12 ? "PM" : "AM";
                                                                h = h % 12 || 12;

                                                                return `${month}/${day}/${year} ${String(h).padStart(2,"0")}:${minute}${ampm}`;
                                                                })()
                                                            : "N/A"}
          
        </span>
      ),
      sortable: false,
    },
    {
      name: 'Recipients',
      selector: (row: any) => row.recipients,
      width: '30%',
      cell: (row: any) => (
        <span className="text-14 text-gray-700">{row.recipients}</span>
      ),
      sortable: false,
    },
    ];

    // Build scheduleData from campaign - combining startDateTime and resendSchedules
    const scheduleData: any[] = [];

    // Add initial campaign start if exists
    if (campaign.startDateTime) {
      scheduleData.push({
        dateTime: campaign.startDateTime,
        recipients: 'All recipients',
      });
    }

    // Add resend schedules
    if (campaign.resendSchedules?.length > 0) {
      campaign.resendSchedules.forEach((schedule: any) => {
        const matchedOption = RESENDTOOPTIONS.find(
          (opt) => String(opt.value) === String(schedule.resendType)
        );
        scheduleData.push({
          dateTime: schedule.resendDateTime,
          recipients: matchedOption ? matchedOption.label : 'N/A',
        });
      });
    }

const buildTemplateImageUrl = (
  baseUrl: string | undefined,
  identifier?: string,
  version?: string
): string | undefined => {
  if (!baseUrl || !identifier || !version) return undefined;
  const trimmed = baseUrl.endsWith("/")
    ? baseUrl.slice(0, -1)
    : baseUrl;
  return `${trimmed}/Template/${identifier}/${version}/Template_Large.png`;
};

const imageUrl = buildTemplateImageUrl(
  TemplateImagePublicURL,
  campaign?.templateIdentifier,
  campaign?.templateVersion
);

    return (
        <div className="flex justify-between items-center">
         
                    <div className="w-full">
                           <div className='mt-[40px]'>
                            <div className="bg-white w-full">
                               
                                {
                                    isDataLoading ?
                                        <div className='flex justify-center items-center relative top-[50%]'><span className="loading loading-spinner text-primary"></span></div> :
                                        <React.Fragment>
                                            <div className="flex flex-row w-full ">
                                                {/* ✅ Left Section: Summary */}
                                                <div className="w-1/2 pr-[20px]">
                                                    <div className="mb-[10px] relative"> {/* Increased width from w-3/4 to w-[85%] */}
                                                        <div className="bg-[#f5f5f5] text-center text-16 font-semibold rounded-full p-[4px] text-muted w-full">
                                                            Summary
                                                        </div>
                                                    </div>

                                                    <div className="">                                                       
                                                        <div className="flex mb-[15px]">
                                                            <span className="text-muted font-semibold w-1/2 text-[14px]">Campaign Name</span>
                                                            <CustomTooltip title={campaign.name} placement='bottom' arrow={false}><span className="text-muted w-1/2 truncate">{campaign.name}</span></CustomTooltip>
                                                        </div>
                                                        <div className="flex mb-[15px]">
                                                            <span className="text-muted font-semibold w-1/2 text-[14px]">Email Template</span>
                                                            <CustomTooltip title={campaign.templateName} placement='bottom' arrow={false}><span className="text-muted w-1/2 truncate">{campaign.templateName}</span></CustomTooltip>
                                                        </div>
                                                        {espConnectionName && (
                                                            <div className="flex mb-[15px]">
                                                                <span className="text-muted font-semibold w-1/2 text-[14px]">Email Service Provider</span>
                                                                <CustomTooltip title={espConnectionName} placement='bottom' arrow={false}><span className="text-muted w-1/2 truncate">{espConnectionName}</span></CustomTooltip>
                                                            </div>
                                                        )}
                                                        {/* ✅ Seed List Name with truncation and tooltip */}
                                                        {seedListName && (
                                                            <div className="flex mb-[15px]">
                                                            <span className="text-muted font-semibold w-1/2 text-[14px]">Seed List</span>
                                                            <CustomTooltip title={seedListName} placement="bottom" arrow={false}>
                                                                <span className="text-muted w-1/2">
                                                                {seedListName.length > 30
                                                                    ? seedListName.substring(0, 30) + "..."
                                                                    : seedListName}
                                                                </span>
                                                            </CustomTooltip>
                                                            </div>
                                                        )}
                                                        
                                                        {/* ✅ Suppression List Name with truncation and tooltip */}
                                                        {suppressionListName && (
                                                            <div className="flex mb-[15px]">
                                                            <span className="text-muted font-semibold w-1/2 text-[14px]">Suppression List</span>
                                                            <CustomTooltip title={suppressionListName} placement="bottom" arrow={false}>
                                                                <span className="text-muted w-1/2">
                                                                {suppressionListName.length > 30
                                                                    ? suppressionListName.substring(0, 30) + "..."
                                                                    : suppressionListName}
                                                                </span>
                                                            </CustomTooltip>
                                                            </div>
                                                        )}
                                                        <div className="flex mb-[15px]">
                                                            <span className="text-muted font-semibold w-1/2 text-[14px]">Priority</span>
                                                            {(() => {const matchedPriority = PRIORITY_OPTIONS.find( (opt) => opt.value === String(campaign.priority) );
                                                                return (
                                                                <CustomTooltip title={matchedPriority?.label ?? ""} placement="bottom" arrow={false}>
                                                                    <span className="text-muted w-1/2 truncate">
                                                                    {matchedPriority ? matchedPriority.label : ""}
                                                                    </span>
                                                                </CustomTooltip>
                                                                );
                                                            })()}
                                                        </div>
                                                        <div className="flex mb-[15px]">
                                                            <span className="text-muted font-semibold w-1/2 text-[14px]">Suppressed Count</span>
                                                            <span className="text-muted w-1/2">{suppressedCount}</span>
                                                        </div>
                                                        <div className="flex mb-[15px]">
                                                            <span className="text-muted font-semibold w-1/2 text-[14px]">Seed Count</span>
                                                            <span className="text-muted w-1/2">{seedCount}</span>
                                                        </div>
                                                        <div className="flex mb-[15px]">
                                                            <span className="text-muted font-semibold w-1/2 text-[14px]">Total Recipients</span>
                                                            <span className="text-muted w-1/2">{totalRecipientCount}</span>
                                                        </div>
                                                        <div className="flex mb-[15px]">
                                                            <span className="text-muted font-semibold w-1/2 text-[14px]">Client Campaign ID</span>
                                                            <span className="text-muted w-1/2">{displayClientCampaignId}</span>
                                                        </div>
                                                        {/* ✅ Campaign Schedule Table using CustomDataTable */}
                                                        {scheduleData.length > 0 && (
                                                            <div className="mt-6">
                                                                <p className="text-15 font-semibold text-muted mb-2">Campaign Schedule</p>
                                                                <div className="csv-data mb-4 mb-4 border rounded-lg bg-white flex flex-col max-h-[400px] p-2" style={{ borderColor: '#E6ECF2' }}>
                                                                    <CustomDataTable
                                                                        columns={scheduleColumns}
                                                                        data={scheduleData}
                                                                        pagination={false}
                                                                      
                                                                    />
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                {/* ✅ Right Section: Template Preview */}
                                                <div className="w-1/2 pl-[20px] flex flex-col items-start">
                                                    <p className="text-16 font-semibold text-muted mb-2">Template Preview</p>
                                                    <div className=" h-[350px] flex items-center justify-center relative w-full border border-[#e6ecf2] rounded-lg">
                                                      
                                                        {campaign?.templateIdentifier ? (
                                                         <>
                                                         {imageUrl && !imageError ? (
                                                            <img
                                                              src={imageUrl}
                                                              alt="Template Preview"
                                                              className="icon-hover"
                                                              style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }}
                                                              onError={() => setImageError(true)}
                                                            />
                                                          ) : (
                                                            <HugeiconsIcon icon={Image03Icon} size={50} color="#6B7280" />
                                                          )}
                                                         </>
                                                       ) : (
                                                         <div className="w-full h-full flex items-center justify-center bg-gray-50 rounded-lg">
                                                           <HugeiconsIcon icon={Image03Icon} size={50} color="#6B7280" />
                                                         </div>
                                                       )}

                                                        {/* Hover View Icon */}
                                                        <div 
                                                          className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 rounded-lg hover:opacity-100 transition-opacity cursor-pointer" 
                                                          onClick={() => setIsPreviewModalOpen(true)}
                                                        >
                                                            <HugeiconsIcon
                                                                icon={ViewStrokeRounded}
                                                                size={24}
                                                                color="currentcolor"
                                                                strokeWidth={0.5}
                                                                className="cursor-pointer text-white"
                                                                // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                                                                onClick={() => setIsPreviewModalOpen(true)}

                                                            />
                                                        </div>
                                                        <TemplatePreview
                                                            isOpen={isPreviewModalOpen}
                                                            onClose={() => setIsPreviewModalOpen(false)}
                                                            content={campaign?.templateContent ?? ''}
                                                            campaignType="BulkCampaign"
                                                            campaignId={campaign.bulkCampaignId || campaign.id}
                                                        />
                                                    </div>
                                                     <div className="text-sm text-gray-700 mt-3">
                                                    <span className="font-semibold text-muted" style={{ fontSize: '14px' }}>Created:</span>
                                                    <span className="font-normal text-muted" style={{ fontSize: '14px' }}> {bulkEmailCreatedOn 
                                                            ? (() => {
                                                                const [datePart, timePart] = bulkEmailCreatedOn.split("T");
                                                                const [year, month, day] = datePart.split("-");
                                                                const [hour, minute] = timePart.substring(0,5).split(":");

                                                                let h = parseInt(hour, 10);
                                                                const ampm = h >= 12 ? "PM" : "AM";
                                                                h = h % 12 || 12;

                                                                return `${month}/${day}/${year} ${String(h).padStart(2,"0")}:${minute}${ampm}`;
                                                                })()
                                                            : moment().format('MM/DD/YYYY h:mmA')} <span style={{ fontStyle: "italic" }}> ({bulkEmailCreatedUser ? bulkEmailCreatedUser : fullname})</span></span>
                                                </div>
                                                   
                                                </div>
                                                       
                                            </div>
                                         

                                           
                                        </React.Fragment>
                                }

                        </div>

                            </div>

                       
                    </div>
               
        </div>
    )
}

export default BulkEmailReview